export const HELLO_RADIUS_DOMAIN_PROD = "https://helloradius.com";
export const HELLO_RADIUS_DOMAIN_DEV =
  "https://helloradius-dev.firebaseapp.com";
export const HOME_PAGE_ROUTE = "/";
export const JOBS_ROUTE = "/jobs";
export const JOB_PATH = "/jobs/:id";
export const COMPANIES_ROUTE = "/companies";
export const COMPANY_PATH = "/companies/:id";
export const ERROR_ROUTE = "/error";
export const ACCOUNT_SIGN_IN_ROUTE = "/sign-in";
export const HANDLE_AUTH_PATH = "/auth";
export const EMPLOYER_DASHBOARD = "employer-dashboard";
export const ACCOUNT_PANE_PATH = "account";
export const EMPLOYER_DASHBOARD_PATH = `/${EMPLOYER_DASHBOARD}/:id`;
export const EMPLOYER_DASHBOARD_MANAGE_JOBS_PATH = `/${EMPLOYER_DASHBOARD}/manage-jobs`;
export const EMPLOYER_DASHBOARD_POST_JOB_PATH = `/${EMPLOYER_DASHBOARD}/post-job`;
export const EMPLOYER_PROMOTION_SERVICES_PATH = `/${EMPLOYER_DASHBOARD}/promotion-services`;
export const EMPLOYER_COMPANY_PROFILE_PATH = `/${EMPLOYER_DASHBOARD}/company-profile`;
export const EMPLOYER_ACCOUNT = `/${EMPLOYER_DASHBOARD}/${ACCOUNT_PANE_PATH}`;
export const ADMIN_PATH = "/admin/:id";
export const ADMIN_DASHBOARD_PATH = "/admin/dashboard";
export const JOB_SEEKER_DASHBOARD = "dashboard";
export const JOB_SEEKER_DASHBOARD_PATH = `/${JOB_SEEKER_DASHBOARD}/:id`;
export const JOB_SEEKER_DASHBOARD_PROFILE_PATH = `/${JOB_SEEKER_DASHBOARD}/my-profile`;
export const ACCOUNT_DELETED_PATH = "/account-deleted/:id";
export const PRICING_PATH = "/pricing";
export const TERMS_AND_CONDITION_ROUTE = "/terms-and-conditions";
export const PRIVACY_POLICY_ROUTE = "/privacy-policy";
export const COOKIES_ROUTE = "/cookies";
export const FAQ_ROUTE = "/support/frequently-asked-questions";
export const PAYMENT_SUCCESS_PATH = "/payment-success/:id";
export const PAYMENT_CANCELED_PATH = "/payment-canceled/:id";
export const COMING_SOON_ROUTE = "/coming-soon";
export const UNDER_MAINTENANCE_ROUTE = "/under-maintenance";
export const BLOG_ROUTE = "/blog";
export const BLOG_PATH = "/blog/:id";
